export type SplitPrefillName = {
    firstName: string;
    lastName: string;
};

// The first token becomes the first name and the remainder the last name; the whole term
// becomes the first name when there is no space. Trimmed first, so a leading/trailing space
// entered in search doesn't survive into the form.
export function splitPrefillName(term: string): SplitPrefillName {
    const trimmed = term.trim();
    if (!trimmed) {
        return { firstName: '', lastName: '' };
    }

    const spaceIndex = trimmed.indexOf(' ');
    if (spaceIndex === -1) {
        return { firstName: trimmed, lastName: '' };
    }

    return {
        firstName: trimmed.slice(0, spaceIndex),
        lastName: trimmed.slice(spaceIndex + 1).trim(),
    };
}
